import { Controller } from "@hotwired/stimulus";

// Turbo Frame 을 교체한 뒤 주소창도 그 프레임이 불러온 주소로 맞춘다(새로고침·공유 시 같은 상태로 열리도록).
//
// 링크에 data-turbo-action 을 주면 Turbo 가 주소를 바꾸려고 방문을 하나 더 시작하는데,
// 그 방문이 새 프레임 안에서 막 시작된 폼 제출(구매 영역의 가격 계산)을 취소해 버린다.
// 그래서 프레임 교체가 끝난 뒤 history 만 조용히 바꾼다.
export default class extends Controller {
  sync() {
    const src = this.element.getAttribute("src");
    if (!src) return;

    history.replaceState(history.state, "", src);
  }
}
